import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { supabase } from '../../lib/supabase';

const STATUS_COLORS = {
     pending: 'bg-orange-500/20 text-orange-300',
     confirmed: 'bg-green-500/20 text-green-300',
     completed: 'bg-blue-500/20 text-blue-300',
     cancelled: 'bg-red-500/20 text-red-300',
};

export default function BookingsList() {
     const [bookings, setBookings] = useState([]);
     const [filter, setFilter] = useState('all');
     const [loading, setLoading] = useState(true);

     useEffect(() => {
          fetchBookings();
          // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [filter]);

     async function fetchBookings() {
          setLoading(true);
          let query = supabase
               .from('bookings')
               .select('*')
               .order('start_date', { ascending: false });

          if (filter !== 'all') {
               query = query.eq('status', filter);
          }

          const { data } = await query;
          setBookings(data || []);
          setLoading(false);
     }

     const filters = ['all', 'confirmed', 'pending', 'completed', 'cancelled'];

     return (
          <div>
               <h1 className='text-darker text-2xl font-bold mb-6'>Bookings</h1>

               {/* Filters */}
               <div className='flex gap-2 mb-6 flex-wrap'>
                    {filters.map((f) => (
                         <button
                              key={f}
                              onClick={() => setFilter(f)}
                              className={`px-3 py-1.5 rounded-lg text-sm capitalize duration-300 ${
                                   filter === f
                                        ? 'bg-yellow/10 text-yellow border border-yellow'
                                        : 'text-darker/40 border border-gray-200 hover:text-darker'
                              }`}
                         >
                              {f}
                         </button>
                    ))}
               </div>

               {/* Table */}
               <div className='bg-white rounded-xl border border-gray-200 overflow-hidden'>
                    {loading ? (
                         <p className='text-darker/40 p-4'>Loading bookings...</p>
                    ) : bookings.length === 0 ? (
                         <p className='text-darker/40 p-4'>No bookings found.</p>
                    ) : (
                         <div className='overflow-x-auto'>
                              <table className='w-full text-left'>
                                   <thead>
                                        <tr className='border-b border-gray-200 text-darker/40 text-sm'>
                                             <th className='p-4'>Customer</th>
                                             <th className='p-4'>Dates</th>
                                             <th className='p-4'>Amount</th>
                                             <th className='p-4'>Status</th>
                                             <th className='p-4'></th>
                                        </tr>
                                   </thead>
                                   <tbody className='divide-y divide-gray-200'>
                                        {bookings.map((booking) => (
                                             <tr
                                                  key={booking.id}
                                                  className='hover:bg-gray-100 duration-300'
                                             >
                                                  <td className='p-4'>
                                                       <p className='text-darker'>
                                                            {booking.customer_name}
                                                       </p>
                                                       <p className='text-darker/40 text-sm'>
                                                            {booking.customer_email}
                                                       </p>
                                                  </td>
                                                  <td className='p-4 text-darker/80 text-sm whitespace-nowrap'>
                                                       {format(new Date(booking.start_date), 'MMM d')} –{' '}
                                                       {format(new Date(booking.end_date), 'MMM d, yyyy')}
                                                  </td>
                                                  <td className='p-4 text-yellow font-bold whitespace-nowrap'>
                                                       ${(booking.total_cents / 100).toLocaleString()}
                                                  </td>
                                                  <td className='p-4'>
                                                       <span
                                                            className={`px-2 py-1 rounded-md text-xs capitalize ${
                                                                 STATUS_COLORS[booking.status] || ''
                                                            }`}
                                                       >
                                                            {booking.status}
                                                       </span>
                                                  </td>
                                                  <td className='p-4'>
                                                       <Link
                                                            to={`/admin/bookings/${booking.id}`}
                                                            className='text-yellow text-sm hover:underline'
                                                       >
                                                            View →
                                                       </Link>
                                                  </td>
                                             </tr>
                                        ))}
                                   </tbody>
                              </table>
                         </div>
                    )}
               </div>
          </div>
     );
}
